module.exports = __webpack_public_path__ + "img/Certificate_10.319f5c39.jpg";